import { OnInit, Directive } from "@angular/core";

@Directive()
export class ReportConstants implements OnInit {
  public filterMessage =
    "Please select all filter fields to generate a report.";

  ngOnInit(): void {
    //do nothing, leave comment to avoid sonar error
  }
}
